// Runtime config — values injected at build time via environment variables
// For local dev, set these in client/.env.local
const config = {
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:3001',
  cognito: {
    userPoolId: process.env.REACT_APP_USER_POOL_ID || '',
    userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '',
    region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
  },
};

export default config;
